import { RestClient } from '../lib/RestClient'

class HomeService extends RestClient {
  constructor() {
    super('home')
  }
}

export const Home = new HomeService()
